import _ from "lodash";

const factorial = (x, acc = 1) => (x < 2 ? acc : factorial(x - 1, x * acc));

const binomDist = (n, x, p) =>
  (factorial(n) / factorial(x) / factorial(n - x)) *
  Math.pow(p, x) *
  Math.pow(1 - p, n - x);

const getDicePoolSuccessPercentage = (
  numberOfSides,
  numberOfDice,
  targetNumber,
  targetSuccesses,
  onesNegateSuccess = false
) => {
  const dieSuccessProbability =
    (numberOfSides - targetNumber + 1) / numberOfSides;

  if (onesNegateSuccess && 1 === targetNumber) {
    // Ones effectively negate themselves, so find the probability of enough non-1 results
    return _.chain(Array.from({ length: numberOfDice - targetSuccesses + 1 }))
      .map((el, index) => targetSuccesses + index)
      .map(successes =>
        binomDist(numberOfDice, successes, (numberOfSides - 1) / numberOfSides)
      )
      .sum()
      .value();
  } else {
    return _.chain(Array.from({ length: numberOfDice - targetSuccesses + 1 }))
      .map((el, index) => targetSuccesses + index)
      .map(successes => {
        // Probability of exactly successes # of success
        const rawSuccessPercentage = binomDist(
          numberOfDice,
          successes,
          dieSuccessProbability
        );

        // Probability of enough 1s in remaining dice to drop successes below targetSuccesses
        const remainingDice = numberOfDice - successes;
        const numberOfOnesNeeded = successes - targetSuccesses + 1;
        const nerfPercentage = _.chain(
          Array.from({ length: remainingDice - numberOfOnesNeeded + 1 })
        )
          .map((el, index) => index + numberOfOnesNeeded)
          .map(numberOfOnes =>
            binomDist(remainingDice, numberOfOnes, 1 / (targetNumber - 1))
          )
          .sum()
          .value();

        const nerfedSuccessPercentage = remainingDice
          ? rawSuccessPercentage * (1 - nerfPercentage)
          : rawSuccessPercentage;

        return onesNegateSuccess
          ? nerfedSuccessPercentage
          : rawSuccessPercentage;
      })
      .sum()
      .value();
  }
};

export { binomDist, getDicePoolSuccessPercentage, factorial };
